import React from "react"
import PropTypes from "prop-types"
import { useParams } from "react-router-dom"
import AppPrivacyPolicy from "pages/PageContent/AppPrivacyPolicy"
import AppTermsConditions from "pages/PageContent/AppTermsConditions"
import TenantPublicPageContent from "./components/TenantPublicPageContent"
import {
  isLegacyPublicLang,
  isTenantPublicUuid,
} from "./utils/publicPageUtils"

const PublicLegalPageRoute = ({ pageType, appType = "customer" }) => {
  const { identifier } = useParams()

  if (isLegacyPublicLang(identifier)) {
    return pageType === "PrivacyPolicy" ? (
      <AppPrivacyPolicy langOverride={identifier} />
    ) : (
      <AppTermsConditions langOverride={identifier} />
    )
  }

  if (isTenantPublicUuid(identifier)) {
    return (
      <TenantPublicPageContent
        tenantUuid={identifier}
        pageType={pageType}
        appType={appType}
      />
    )
  }

  return pageType === "PrivacyPolicy" ? (
    <AppPrivacyPolicy langOverride="en" />
  ) : (
    <AppTermsConditions langOverride="en" />
  )
}

PublicLegalPageRoute.propTypes = {
  pageType: PropTypes.oneOf(["PrivacyPolicy", "TermsAndConditions"]).isRequired,
  appType: PropTypes.oneOf(["customer", "rider"]),
}

export default PublicLegalPageRoute
